// Pregunta 1: ¿Cómo tienes previsto realizar el pago?

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PAYMENT_OPTIONS } from '../../../config/buyerProfileOptions';

export const PaymentMethodQuestion = ({ value, onChange, error }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-white">
        {t('questions.payment.question')} <span className="text-red-400">*</span>
      </label>

      <div className="space-y-2">
        {PAYMENT_OPTIONS.map((option) => (
          <label
            key={option.value}
            className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
              value === option.value
                ? 'bg-amber-500/10 border-amber-500 text-white'
                : 'bg-slate-800/50 border-slate-700 text-slate-300 hover:border-slate-600'
            }`}
          >
            <input
              type="radio"
              name="payment_method"
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              className="w-4 h-4 text-amber-500 focus:ring-amber-500"
            />
            <span className="text-sm">{t(option.labelKey)}</span>
          </label>
        ))}
      </div>

      {error && (
        <p className="text-xs text-red-400 mt-1">{error}</p>
      )}
    </div>
  );
};

export default PaymentMethodQuestion;
